<template>
	<div class="addressBar">
		<ul class="PL fr flexDiv">
      <li v-for="(item,index) in addressBarData.List" :to="item.Url" :href="item.Url" :key='item.ID'>
        <router-link :to="item.Url"  :class="[item.Name == addressBarData.lanmu.Name ? 'on' : '']"
          :href="item.Url">{{ item.Name }}</router-link>
      </li>
    </ul>
		<p class="PR fl">
			 <!-- 当前所在位置：<router-link to="./" >首页>&nbsp;</router-link> -->
			<!-- <router-link v-if="addressBarData.PColumn" :href="addressBarData.PColumn.Url" :to="addressBarData.PColumn.Url"  @click.native="OpenLink(item.Url)">{{addressBarData.PColumn.Name}} >&nbsp;</router-link> -->
			<!-- <router-link :to="addressBarData.lanmu.Url"  :href="addressBarData.lanmu.Url"  @click.native="OpenLink(addressBarData.lanmu.Url)" >{{addressBarData.lanmu.Name}}</router-link> -->
      <router-link :to="addressBarData.lanmu.Url">
        <span>{{addressBarData.lanmu.Name}}</span>
        <em v-if="!addressBarData.lanmu.Aliase">{{addressBarData.PColumn.Aliase}}</em>
        <em v-else>{{addressBarData.lanmu.Aliase}}</em>
      </router-link>
		</p>
	</div>
</template>

<script>
	export default{
		name:'addressBar',
		props:{
			addressBarData:{
				type: Object,
        default: () => {
          return {
          PColumn:{},
          lanmu:{},
          List:[]
          }
        }
			},
			moreLink: {
			   type: String,
			   default: ''
			 }
		}
	}
</script>

<style lang="less" scoped="scoped">
	.addressBar{
    position: relative;
		.PL{
      color: #333333;
			font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 78px;
      letter-spacing: 1px;
      margin-right: 25px;
      li{
        display: inline-block;
        margin-left: 30px;
        .on{
          color: #0069B7;
        }
      }
      a.router-link-exact-active,a.on{
        color: #0069B7;
        &::after{
          content: '';
          width: 51px;
          height: 1px;
          background-color: #0069B7;
          position: absolute;
          left: 8px;
          bottom: 16px;
        }
      }
      a{
        display: inline-block;
        position: relative;
      }
		}
		.PR{
      position: relative;
      margin-top: 24px;
      margin-left: 10px;
      a.router-link-exact-active{
        color: #005a99;
      }
      &::before{
        content: '';
        width: 3px;
        height: 34px;
        background: #32454F;
        position: absolute;
        left: -10px;
        top: -3px;
      }
      span{
        display: block;
        font-size: 18px;
        font-weight: normal;
        color: #32454F;
        line-height: 12px;
        letter-spacing: 2px;
      }
      em{
        font-size: 12px;
        font-family: Helvetica;
        font-weight: normal;
        color: #32454F;
      }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/addressBar.vue